// src/com/trans_plan_return/TransPlanReturnDict.js
import { InputType } from "../../value/AppConst";
import IsValid from "../../value/IsValid";

const FLOAT_NUM_PATTERN = /^-?\d+(\.\d+)?$/;

// 센터반납 정보, trans_plan_return
const Dict = {
    // toAdd, toEdit : mark if need to submit for mutation
    planId : {
		id: 'planId', label: '배차번호', required: true, toAdd: true, toEdit: true,
	}, // varchar(12)
    inputDptrTime : {
		id: 'inputDptrTime', label: '점포출발',
		type: InputType.datetime, required: true, toAdd: true, toEdit: true,
	}, // timestamp
    inputArrTime : {
		id: 'inputArrTime', label: '점포도착',
		type: InputType.datetime, required: true, toAdd: true, toEdit: true,
	}, // timestamp
    inputTempF : {
		id: 'inputTempF', label: '도착온도(전면)',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '정확한 온도를 입력하세요.',
		check: (value) => IsValid.nullString(value) || FLOAT_NUM_PATTERN.test(value),
	}, // varchar(8)
    inputTempM : {
		id: 'inputTempM', label: '도착온도(중면)',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '정확한 온도를 입력하세요.',
		check: (value) => IsValid.nullString(value) || FLOAT_NUM_PATTERN.test(value),
	}, // varchar(8)
    inputTempR : {
		id: 'inputTempR', label: '도착온도(후면)',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '정확한 온도를 입력하세요.',
		check: (value) => IsValid.nullString(value) || FLOAT_NUM_PATTERN.test(value),
	}, // varchar(8)
    // #################### 센터반납 전반
    dcReturnKpp : {
		id: 'dcReturnKpp', label: 'KPP', // 팔레트
		type: InputType.number, required: false, toAdd: true, toEdit: true,
		check: (value) => {return value >= 0 && value <= 9999},
	}, // int(3)
    dcReturnAju : {
		id: 'dcReturnAju', label: 'AJU', // 팔레트.
		type: InputType.number, required: false, toAdd: true, toEdit: true,
		check: (value) => {return value >= 0 && value <= 9999},
	}, // int(3)
    dcReturnStackKpp : {
		id: 'dcReturnStackKpp', label: 'KPP', // 집기적재팔렛트
		type: InputType.number, required: false, toAdd: true, toEdit: true,
		check: (value) => {return value >= 0 && value <= 9999},
	}, // int(11)
    dcReturnStackAju : {
		id: 'dcReturnStackAju', label: 'AJU', // 집기적재팔렛트
		type: InputType.number, required: false, toAdd: true, toEdit: true,
		check: (value) => {return value >= 0 && value <= 9999},
	}, // int(11)
    dcReturnSpt : {
		id: 'dcReturnSpt', label: '532', // Single Pick Tray
		type: InputType.number, required: false, toAdd: true, toEdit: true,
		check: (value) => {return value >= 0 && value <= 9999},
	}, // int(4)
    dcReturnSpt533 : {
		id: 'dcReturnSpt533', label: '533', // Single Pick Tray
		type: InputType.number, required: false, toAdd: true, toEdit: true,
		check: (value) => {return value >= 0 && value <= 9999},
	}, // int(3)
    dcReturnFull : {
		id: 'dcReturnFull', label: 'FULL', // 보냉커버
		type: InputType.number, required: false, toAdd: true, toEdit: true,
		check: (value) => {return value >= 0 && value <= 9999},
	}, // int(3)
    dcReturnHalf : {
		id: 'dcReturnHalf', label: 'HALF', // 보냉커버
		type: InputType.number, required: false, toAdd: true, toEdit: true,
		check: (value) => {return value >= 0 && value <= 9999},
	}, // int(3)
    // #################### 센터반납 후반
    dcReturnNjc800 : {
		id: 'dcReturnNjc800', label: 'NJC800',
		type: InputType.number, required: false, toAdd: true, toEdit: true,
		check: (value) => {return value >= 0 && value <= 9999},
	}, // int(4)
    dcReturnRollcage : {
		id: 'dcReturnRollcage', label: 'Roll Cage',
		type: InputType.number, required: false, toAdd: true, toEdit: true,
		check: (value) => {return value >= 0 && value <= 9999},
	}, // int(3)
    dcReturnDanpra : {
		id: 'dcReturnDanpra', label: 'Danpra',
		type: InputType.number, required: false, toAdd: true, toEdit: true,
		check: (value) => {return value >= 0 && value <= 9999},
	}, // int(4)
    dcReturnWooden : {
		id: 'dcReturnWooden', label: '우든칼라',
		type: InputType.number, required: false, toAdd: true, toEdit: true,
		check: (value) => {return value >= 0 && value <= 9999},
	}, // int(11)
    dcReturnOctagon : {
		id: 'dcReturnOctagon', label: '옥타곤',
		type: InputType.number, required: false, toAdd: true, toEdit: true,
		check: (value) => {return value >= 0 && value <= 9999},
	}, // int(11)
    dcReturnEtc : {
		id: 'dcReturnEtc', label: '기타',
		type: InputType.number, required: false, toAdd: true, toEdit: true,
		check: (value) => {return value >= 0 && value <= 9999},
	}, // int(3)
    // #################### 점간대출
    dcCoverStores : {
		id: 'dcCoverStores', label: '점간대출 점포',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '20자 이내로 입력하세요.',
		check: (value) => {return IsValid.nullString(value) || IsValid.string(value, 1, 60)},
	}, // varchar(60)
    dcReturnSealNo : {
		id: 'dcReturnSealNo', label: '봉인번호(1)',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '10자 이내로 입력하세요.',
		check: (value) => {return IsValid.nullString(value) || IsValid.string(value, 0, 10)},
	}, // varchar(10)
    dcReturnSealNo2 : {
		id: 'dcReturnSealNo2', label: '봉인번호(2)',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '10자 이내로 입력하세요.',
		check: (value) => {return IsValid.nullString(value) || IsValid.string(value, 0, 10)},
	}, // varchar(10)
    dcReturnSealNo3 : {
		id: 'dcReturnSealNo3', label: '봉인번호(3)',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '10자 이내로 입력하세요.',
		check: (value) => {return IsValid.nullString(value) || IsValid.string(value, 0, 10)},
	}, // varchar(10)
    dcCoverItem1 : {
		id: 'dcCoverItem1', label: 'PT',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '40자 이내로 입력하세요.',
		check: (value) => {return IsValid.nullString(value) || IsValid.string(value, 0, 40)},
	}, // varchar(40)
    dcCoverItem2 : {
		id: 'dcCoverItem2', label: '롤케이지',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '40자 이내로 입력하세요.',
		check: (value) => {return IsValid.nullString(value) || IsValid.string(value, 0, 40)},
	}, // varchar(40)
    dcReturnNote : {
		id: 'dcReturnNote', label: '비고',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '400자 이내로 입력하세요.',
		check: (value) => {return IsValid.nullString(value) || IsValid.string(value, 0, 400)},
	}, // varchar(400)
    /*
    returnDriverCheckYn : {
		id: 'returnDriverCheckYn', label: 'returnDriverCheckYn',
		type: InputType.checkbox, required: false, toAdd: true, toEdit: true,
		help: '1자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 1)},
		trueValue: 'Y', falseValue: 'N',
	}, // enum('N','Y')
    returnDriverCheckDate : {
		id: 'returnDriverCheckDate', label: 'returnDriverCheckDate',
		type: InputType.datetime, required: false, toAdd: true, toEdit: true,
	}, // timestamp
    returnStoreCheckYn : {
		id: 'returnStoreCheckYn', label: 'returnStoreCheckYn',
		type: InputType.checkbox, required: false, toAdd: true, toEdit: true,
		help: '1자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 1)},
		trueValue: 'Y', falseValue: 'N',
	}, // enum('N','Y')
    returnStoreCheckDate : {
		id: 'returnStoreCheckDate', label: 'returnStoreCheckDate',
		type: InputType.datetime, required: false, toAdd: true, toEdit: true,
	}, // timestamp
    returnDcCheckYn : {
		id: 'returnDcCheckYn', label: 'returnDcCheckYn',
		type: InputType.checkbox, required: false, toAdd: true, toEdit: true,
		help: '1자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 1)},
		trueValue: 'Y', falseValue: 'N',
	}, // enum('N','Y')
    returnDcCheckDate : {
		id: 'returnDcCheckDate', label: 'returnDcCheckDate',
		type: InputType.datetime, required: false, toAdd: true, toEdit: true,
	}, // timestamp
    returnDcCheckUser : {
		id: 'returnDcCheckUser', label: 'returnDcCheckUser',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '20자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 40)},
	}, // varchar(40)
    collectorDate : {
		id: 'collectorDate', label: 'collectorDate',
		type: InputType.datetime, required: false, toAdd: true, toEdit: true,
	}, // timestamp
    collectorSignature : {
		id: 'collectorSignature', label: 'collectorSignature',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '4294967295자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 4294967295)},
	}, // longtext
    dcCoverStore1 : {
		id: 'dcCoverStore1', label: 'dcCoverStore1',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '40자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 20)},
	}, // varchar(20)
    dcCoverStore2 : {
		id: 'dcCoverStore2', label: 'dcCoverStore2',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '20자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 20)},
	}, // varchar(20)
    dcCoverStore3 : {
		id: 'dcCoverStore3', label: 'dcCoverStore3',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '20자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 20)},
	}, // varchar(20)
    dcCoverItem3 : {
		id: 'dcCoverItem3', label: 'dcCoverItem3',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '40자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 40)},
	}, // varchar(40)
     */

    
};

const NoReturnDict = {
    planId : {
		id: 'planId', label: 'planId', required: true, toAdd: true, toEdit: true,
	}, // varchar(12)
    dcNoReturnCode : {
		id: 'dcNoReturnCode', label: '사유 카테고리',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '2자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 2)},
	}, // varchar(2)
    dcNoReturnNote : {
		id: 'dcNoReturnNote', label: '사유',
		type: InputType.text, required: false, toAdd: true, toEdit: true,
		help: '100자 이내로 입력하세요.',
		check: (value) => {return IsValid.string(value, 0, 100)},
	}, // varchar(100)

};

/**
 * TRANS_PLAN_RETURN React Component Dictionary for Input and Output
 * Project: NewTOP for cloud
 * 2024-12-27 15:54:42 using DbdbTap
 * https://www.dbdbtap.com
 */
export const TransPlanReturnDictionary = {
    inputMap: Dict,
    noReturnMap: NoReturnDict,
    errorTitle: {
        Save: '반납정보 저장 오류',
        SetNoReturn: '반납정보 미입력 사항 저장 오류',
        Get: '물류집기 반납정보 조회 오류',
    },
};
